/*
 * @Descripttion:
 * @Author: dengyao
 * @Date: 2024-05-31 13:43:44
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-24 16:58:24
 */
import request from '@/service/request'
export default class commonService {
  /**
   * 获取数据字典
   * @param data
   * @returns
   */
  static getDictValue(data: any): Promise<any> {
    return request.post('/dict-value/getDictValue', data)
  }
  /**
   * 根据字典type获取字典数据
   * @param data
   * @returns
   */
  static getListDictDataList(data: any): Promise<any> {
    return request.post('/dict-value/listDictData', data)
  }
  /**
   * 文件上传
   * @param data
   * @returns
   */
  static uploadFile(data: FormData): Promise<any> {
    return request.upload('/architecture/upload', data)
  }
  /**
   * 查询客户信息
   * @param data - 请求参数
   */
  static getStationDetail(data: any): Promise<any> {
    return request.get('/station/detail', data)
  }
}
